import dayjs from "dayjs"
import { z } from "zod"

import type { File as AerosFile } from "@/graphql/codegen/graphql"

const CompanyCertificationAddFormSchema = z
  .object({
    effectiveDate: z.string().min(1, "Effective Date is required"),
    expirationDate: z.string().min(1, "Expiration Date is required"),
    image: z
      .union([z.instanceof(File), z.custom<AerosFile>()]) // workaround to handle preview files from BE
      .nullable()
      .refine((file) => file !== null, {
        message: "Please upload a file",
      }),
  })
  .refine(
    (data) =>
      !data.expirationDate || (data.effectiveDate && dayjs(data.effectiveDate).isBefore(dayjs(data.expirationDate))),
    {
      message: "Expiration date must be after the effective date",
      path: ["expirationDate"],
    }
  )

export const CompanyCertificationFormSchema = z.object({
  certificationType: z.string().min(1, "Certification Type is required"),
  locationIds: z.array(z.string()).min(1, "Location is required"),
  newCompanyCertification: z.array(CompanyCertificationAddFormSchema),
})

export const UpdateCompanyCertificationFormSchema = z.object({
  certificationType: z.string().min(1, "Certification Type is required"),
  locationId: z.string().min(1, "Location is required"),
  companyCertifications: z.array(CompanyCertificationAddFormSchema),
})

export type UpdateCompanyCertificationFormValues = z.infer<typeof UpdateCompanyCertificationFormSchema>
export type CompanyCertificationFormValues = z.infer<typeof CompanyCertificationFormSchema>

export type CompanyCertificationAddFormValues = z.infer<typeof CompanyCertificationAddFormSchema>
